import React, { FC } from 'react';
import { Header } from './Header';
import { ErrorResponse } from '../services/model';

export const ErrorElement: FC<{ error: ErrorResponse }> = ({ error }) => (
    <div>
        <Header logoHref="/apis" />
        <main className="container">
            <h1>Error {error.status}</h1>
            <div>{error.message}</div>
        </main>
    </div>
);
